<template>
  <div>
    <div class="top-info">
      <div class="video-box" v-if="monitorNum > 0">
        <tc-player
          ref="tcplayer"
          :playVideo="playVideo"
          :widthHeigt="[100, 100]"
        ></tc-player>
      </div>
      <div class="video-box" v-else>
        <img src="@/assets/img/schoolMonitorCenter/paperbroke.png" alt="" />
        <div class="txt">暂无接入信息</div>
      </div>
      <div class="top-sel">
        <!-- <div class="sel-option" @click="getUniversitySafetyCenter">
          <img src="@/assets/img/bigDataCollge/branch-icon.png" alt="分校" />
        </div>
        <div class="sel-option" @click="getHeadUniversitySafetyCenter">
          <img src="@/assets/img/bigDataCollge/head-icon.png" alt="总校" />
        </div> -->
      </div>
    </div>
    <div class="info">
      <!-- 轮播 -->
      <div class="video-list">
        <div class="block" v-if="newArray.length > 0">
          <el-carousel
            trigger="click"
            height="80px"
            :autoplay="isAutoplay"
            indicator-position="none"
            arrow="always"
          >
            <el-carousel-item
              class="carousel-item clearfix"
              v-for="(item, index) in newArray"
              :key="index"
            >
              <div
                class="video"
                v-for="(inner, index) in item"
                :key="index"
                @click="select(inner)"
              >
                <span class="video-address">{{ inner.monitorName }}</span>
                <span class="video-school">{{ schoolName }}</span>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <safety-center-college
        :collegeList="collegeList"
        v-if="collegeList.length > 0"
      ></safety-center-college>
    </div>
  </div>
</template>

<script>
import TcPlayer from "./TcPlayer.vue";
import SafetyCenterCollege from "./SafetyCenterCollege";
export default {
  name: "SafetyCenter",
  components: {
    TcPlayer,
    SafetyCenterCollege
  },
  props: {},
  data() {
    return {
      eduInfo: JSON.parse(sessionStorage.getItem("eduInfo")),
      collegeList: [],
      monitorNum: 0,
      playVideo: {},
      newArray: [],
      isAutoplay: false,
      isHeadUniversity: false
    };
  },
  created() {
    this.getUniversitySafetyCenter();
  },
  mounted() {},
  computed: {
    universitySelectCollege() {
      return this.$store.state.universitySelectCollege;
    },
    universitySelectVideo() {
      return this.$store.state.universitySelectVideo;
    }
  },
  watch: {
    universitySelectCollege() {
      // console.log(this.universitySelectCollege);
      this.monitorNum = this.universitySelectCollege.numberMonitoring;
      this.modify();
    },
    universitySelectVideo() {
      // console.log(this.universitySelectVideo);
      this.select(this.universitySelectVideo);
    }
  },
  methods: {
    async getUniversitySafetyCenter() {
      this.isHeadUniversity = false;
      let req = {
        // eduId: 3
        eduId: this.eduInfo.eduId
      };
      let res = await this.$Http.getUniversitySafetyCenter(req);
      // console.log(res);
      if (res.code == 200) {
        if (res.data) {
          this.collegeList = res.data;
          this.initPLay();
          this.$store.commit(
            "updateUniversitySelectCollege",
            this.collegeList[0]
          );
        }
      } else if (res.code == 101) {
        this.collegeList = [];
        this.modify();
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    async getHeadUniversitySafetyCenter() {
      this.isHeadUniversity = true;
      let req = {
        // eduId: 3
        collegeId: this.eduInfo.eduId
      };
      let res = await this.$Http.getHeadUniversitySafetyCenter(req);
      // console.log(res);
      if (res.code == 200) {
        if (res.data.length > 0) {
          this.monitorNum = res.data.length;
          this.select(res.data[0]);
          this.collegeList = [];
          this.modify(res.data);
        }
      } else if (res.code == 101) {
        this.collegeList = [];
        this.monitorNum = 0;
        this.modify();
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    initPLay() {
      if (
        this.collegeList.length > 0 &&
        this.collegeList[0].monitorNameConnection.length > 0
      ) {
        this.monitorNum = this.collegeList[0].numberMonitoring;
        let monitor = this.collegeList[0].monitorNameConnection[0];
        this.playVideo = {
          // id: item.safeMonitorLiveEzviz.id,
          m3u8_sd: monitor.hls,
          m3u8_hd: monitor.hlsHd,
          flv_sd: monitor.flv,
          flv_hd: monitor.flvHd,
          videoAddress: monitor.monitorName
        };
      } else {
        this.monitorNum = 0;
        this.playVideo = {};
      }
    },
    // 修改返回视频数组结构
    modify(list) {
      // console.log(list);
      if (
        (this.collegeList.length > 0 && this.monitorNum > 0) ||
        (list && list.length > 0)
      ) {
        let videoList = [];
        // console.log(this.isHeadUniversity);
        if (this.isHeadUniversity) {
          videoList = list;
          this.schoolName = this.eduInfo.eduBuresuName;
        } else {
          videoList = this.universitySelectCollege.monitorNameConnection;
          this.schoolName = this.universitySelectCollege.schoolName;
        }
        // console.log(videoList);
        let newArray = [];
        let start = 0;
        let end = 3;
        let length = videoList.length;
        let times = parseInt(length / 3);
        if (times * 3 <= length) {
          times++;
        }
        for (var i = 0; i < times; i++) {
          let sliceArray = videoList.slice(start, end);
          start = end;
          end = end + 3;
          if (sliceArray.length > 0) {
            newArray.push(sliceArray);
          }
        }
        this.newArray = newArray;
        // console.log(newArray);
      } else {
        this.newArray = [];
      }

      // console.log(newArray);
    },
    // 选择视频
    select(item) {
      // console.log(item);
      this.playVideo = {
        // id: item.safeMonitorLiveEzviz.id,
        m3u8_sd: item.hls,
        m3u8_hd: item.hlsHd,
        flv_sd: item.flv,
        flv_hd: item.flvHd,
        videoAddress: item.monitorName
      };
    }
  },
  destroyed() {}
};
</script>

<style lang="scss" scoped>
.top-info {
  padding: 20px 60px 0 90px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  .video-box {
    flex: 0 0 1;
    width: 440px;
    height: 300px;
    padding: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background: url("~@/assets/img/bigDataCollge/video-bg.png") center center
      no-repeat;
    background-size: 100% 100%;
    .txt {
      margin-top: 10px;
      color: #ffffff;
      font-size: 14px;
    }
  }
  .top-sel {
    display: flex;
    justify-content: center;
    align-items: center;
    .sel-option {
      cursor: pointer;
      color: #fff;
      width: 84px;
      height: 81px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
.info {
  // display: flex;
  // justify-content: flex-start;
}
.video-list {
  margin-top: 10px;
  padding-left: 90px;
  width: 530px;
  height: 80px;
  .el-carousel__arrow {
    background: transparent;
  }
  .carousel-item {
    display: flex;
    justify-content: center;
    align-items: center;
    .video {
      width: 140px;
      height: 80px;
      float: left;
      margin-right: 15px;
      cursor: pointer;
      background: url("~@/assets/img/schoolMonitorCenter/video-list-bg.png")
        center center no-repeat;
      background-size: 100% 100%;
      text-align: center;
      position: relative;
      &:last-child {
        margin-right: 0;
      }
    }
    .video-address {
      display: inline-block;
      width: 72px;
      height: 18px;
      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #dbe1ff;
      line-height: 14px;
      text-align: center;
      overflow: hidden;
      word-break: break-all;
      text-overflow: ellipsis;
      white-space: nowrap;
      position: relative;
      top: -2px;
    }
    .video-school {
      display: inline-block;
      width: 140px;
      height: 26px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 26px;
      overflow: hidden;
      word-break: break-all;
      text-overflow: ellipsis;
      white-space: nowrap;
      background: rgba(0, 0, 0, 0.2);
      position: absolute;
      left: 0;
      bottom: 0;
    }
  }
}
</style>
